import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const stepTextVariants = tv({
  base: 'text-nowrap text-[1.25rem] leading-6 min-w-max',
  variants: {
    variant: {
      active: 'text-primary font-semibold',
      'not-started': 'text-onLight-medium',
      done: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'not-started',
  },
});

export type ProgressStepperProps = {
  steps: {
    name: string;
    status: 'active' | 'done' | 'not-started';
    icon?: React.ReactNode;
    disableDefaultIcon?: boolean;
    dataTestId: string;
  }[];
  disableClick: boolean;
  handleStepClick: (index: number) => void;
  isEmbedded?: boolean;
};

export const ProgressStepper = (props: ProgressStepperProps) => (
  <div className="-border-spacing-2 flex w-max border-collapse items-center gap-x-3 border-b border-gray-200">
    {props.steps.map((step, index) => (
      <button
        key={index}
        type="button"
        disabled={step.status === 'not-started' || props.disableClick}
        className={cn('relative flex px-4 py-2 transition-all')}
        onClick={() => {
          props.handleStepClick(index);
        }}
        data-testid={step.dataTestId}
      >
        <span
          className={cn(stepTextVariants({ variant: step.status }), {
            'text-primary-600': props.isEmbedded && step.status === 'active',
            'text-primary-200': props.isEmbedded && step.status === 'done',
          })}
        >
          {step.name}
        </span>
        {/* // HACK: allows overlapping borders with gap in the parent element */}
        <div
          className={cn(
            'absolute -bottom-[1px] left-0 right-0 h-[1px] w-full border-b',
            {
              'border-primary-500':
                step.status === 'active' && !props.isEmbedded,
              'border-primary-600':
                step.status === 'active' && props.isEmbedded,
              'border-gray-200': step.status !== 'active',
            },
          )}
        />
      </button>
    ))}
  </div>
);
